import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import { AlertConfirmHookType } from "commons/hooks/useAlertConfirm";

import AlertTitle from "commons/ui/alert/AlertTitle";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

type PropsType = {
    alertConfirmHook: AlertConfirmHookType;
};

function AlertConfirm(props: PropsType) {
    return props.alertConfirmHook.isOpen ? (
        <Dialog open={true} onClose={props.alertConfirmHook.close} maxWidth={"xs"} scroll={"paper"}>
            <GridColumn className={"dialog-alert"}>
                <AlertTitle title={props.alertConfirmHook.title} />

                <GridItem className={"dialog-message"}>
                    <GridRow>
                        <GridItem className={"col-xs-10-10"}>
                            {typeof props.alertConfirmHook.message === "string" ? (
                                <p>{props.alertConfirmHook.message}</p>
                            ) : (
                                props.alertConfirmHook.message
                            )}
                        </GridItem>
                    </GridRow>
                </GridItem>

                {props.alertConfirmHook.extraConfirmButtonLabel ? (
                    <div className={"options-with-extra-confirm-container"}>
                        <GridItem>
                            <Button
                                onClick={props.alertConfirmHook.confirm}
                                variant={"contained"}
                                color={"primary"}
                            >
                                {props.alertConfirmHook.confirmButtonLabel}
                            </Button>
                        </GridItem>
                        <GridItem>
                            <Button
                                onClick={props.alertConfirmHook.extraConfirm}
                                variant={"contained"}
                                color={"primary"}
                            >
                                {props.alertConfirmHook.extraConfirmButtonLabel}
                            </Button>
                        </GridItem>
                        <GridItem>
                            <Button
                                variant={"outlined"}
                                color={"primary"}
                                className={"secondary-button"}
                                onClick={props.alertConfirmHook.close}
                            >
                                {props.alertConfirmHook.cancelButtonLabel}
                            </Button>
                        </GridItem>
                    </div>
                ) : (
                    <GridItem>
                        <GridRow justifyContent={"center"}>
                            <GridItem>
                                <Button
                                    variant={"outlined"}
                                    color={"primary"}
                                    className={"secondary-button"}
                                    onClick={props.alertConfirmHook.close}
                                >
                                    {props.alertConfirmHook.cancelButtonLabel}
                                </Button>
                            </GridItem>
                            <GridItem>
                                <Button
                                    onClick={props.alertConfirmHook.confirm}
                                    variant={"contained"}
                                    color={"primary"}
                                >
                                    {props.alertConfirmHook.confirmButtonLabel}
                                </Button>
                            </GridItem>
                        </GridRow>
                    </GridItem>
                )}
            </GridColumn>
        </Dialog>
    ) : null;
}

export default AlertConfirm;
